<template>
  <div v-if="showmodal">

    <!-- Modal -->
    <div class="modal fade show" style="display:block;" tabindex="-1">

      <div class="modal-dialog">
        <div class="modal-content">

          <div class="modal-header justify-content-center">
            <h5 class="modal-title">Billing details</h5>
            <button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">

            <div class="form-group">
              <div class="container-comm">
                <div class="container-comm">
                  <input type="text" class="form-control" :value="BillingData.service_name" disabled />
                  <label for="pname">
                    <b>Service name</b>
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="container-comm">
                <input type="text" class="form-control" v-model="editableAmount" @input="onAmountInput"
                  :class="{ 'error-msg-hold': isAmountValid }"/>
                <label for="pname">
                  <b>Amount ({{ currency }})</b>
                </label>
              </div>
            </div>
            <div class="form-group">
              <div class="self-hold">
                <div class="select" :class="{ 'error-msg-hold': ispaymentValid }">
                  <!-- <select id="change" -->
                  <select class="select-text" required v-model="paymentmode">
                    <option value="" disabled selected></option>
                    <option value="cash">
                      Cash
                    </option>
                    <!-- <option value="online">
                      Online
                    </option> -->
                    <!-- <option value="credit_card">
                      Credit Card
                    </option>
                    <option value="debit_card">
                      Debit Card
                    </option> -->
                    <option value="upi">
                      UPI
                    </option>
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                  <label class="select-label">{{ $t('PaymentMode') }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="primary-btn" @click="submitBilling" :disabled="disablesave"
              :class="{ 'global-disabled': disablesave }">
              Save
            </button>
            <a class="quick-billing view-invoice" @click="!disableinvoicereceipt && getviewinvoice()"
              href="javascript:void(0)" data-toggle="tooltip" data-placement="top" style="padding-left: 10px;"
              title="View Invoice" :class="{ 'global-disabled': disableinvoicereceipt }">

              <img src="@/static/images/invoice-black.png">
            </a>

            <a class="quick-billing view-receipt" @click="!disableinvoicereceipt && getviewreceipt()"
              href="javascript:void(0)" data-toggle="tooltip" data-placement="top" style="padding-left: 10px;"
              title="View Receipt" :class="{ 'global-disabled': disableinvoicereceipt }">

              <img src="@/static/images/receipt-black.png">
            </a>
            <!-- <button class="primary-btn" @click="getviewinvoice" :disabled="disableinvoicereceipt" :class="{'global-disabled':disableinvoicereceipt}">
              View Inovice
            </button>
            <button class="primary-btn" @click="getviewreceipt" :disabled="disableinvoicereceipt" :class="{'global-disabled':disableinvoicereceipt}">
              View Receipt
            </button> -->
          </div>
          <div v-if="showspinner">
            <div class="processing_popup full-spinner" style="visibility: visible">
              <div class="spinner">
                <div class="bounce1"></div>
                <div class="bounce2"></div>
                <div class="bounce3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    <!-- Backdrop -->
    <div v-if="showinvoice">
      <InvoicePopup :appointmentid="appt_id" @closeinvoice="closeinvoicepopup()"></InvoicePopup>
    </div>
    <!-- Invoice Details Pop-Up End--><!-- Invoice Details Pop-Up End-->
    <!-- Receipt Details Pop-Up -->
    <div v-if="showreceipt">
      <ReceiptPopup :appointmentid="appt_id" @closereceipt="closereceiptpopup()"></ReceiptPopup>
    </div>
    <transition name="fade">
      <Messages v-if="isdisplaymsg" v-bind:datamessage="sucessmsgtext" v-on:closemsg="closeMessage"
        :iserror="iserrormsg" v-bind:isVisible="isdisplaymsg"></Messages>
    </transition>
  </div>
</template>

<script>
import InvoiceReceiptApi from "../../api/InvoiceReceipt.js";
import InvoicePopup from "@/components/InvoiceReceiptComponent/InvoicePopupComponent.vue";
import ReceiptPopup from "@/components/InvoiceReceiptComponent/ReceiptPopupComponent.vue";
import Messages from "@/components/MessagePopup/Messages";
import rest_service from "../../api/rest_service";
export default {
  props: {
    showmodal: Boolean,
    BillingData: {
      type: Object,
      default: () => ({})
    },
    appointmentdetails: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    InvoicePopup,
    ReceiptPopup,
    Messages
  },
  data() {
    return {
      isdisplaymsg: false,
      sucessmsgtext: "",
      iserrormsg: false,
      currency: "",
      showspinner: false,
      editableAmount:  0,
      isAmountValid: false,
      paymentmode: "",
      ispaymentValid: false,
      showreceipt: false,
      showinvoice: false,
      appt_id: null,
      //appointmentdetails: null,
      disableinvoicereceipt: true,
      disablesave: false,
    }
  },
  mounted() {
    this.disableinvoicereceipt = true;
    this.disablesave = false;
    if (localStorage.TenantCurrency) {
      var Currency = JSON.parse(window.localStorage.getItem("TenantCurrency"));
      if (Currency)
        this.currency = Currency.symbol;
    }
    else {
      var tenantId = localStorage.tenantid;
      rest_service.GetCurrency(tenantId).then(response => {
        var Currency = JSON.parse(window.localStorage.getItem("TenantCurrency"));
        if (Currency)
          this.currency = Currency.symbol;
      });
    }
    $('[data-toggle="tooltip"]').tooltip({
      trigger: "hover",
    });
  },
  methods: {
    loadstatusmessage(message, iserror) {
      this.isdisplaymsg = true;
      this.iserrormsg = iserror;
      this.sucessmsgtext = message;
    },
    closeMessage() {
      this.isdisplaymsg = false;
    },
    getviewinvoice() {
      this.appointmentdetails = this.appointmentdetails;
      this.appt_id = this.appointmentdetails.unique_id;
      this.showinvoice = true;
    },
    closeinvoicepopup() {
      this.showinvoice = false;
    },
    getviewreceipt() {
      this.appointmentdetails = this.appointmentdetails;
      this.appt_id = this.appointmentdetails.unique_id;
      this.showreceipt = true;
    },
    closereceiptpopup() {
      this.showreceipt = false;
    },
    closeModal() {
      this.paymentmode="";
      this.disablesave = false;
      this.disableinvoicereceipt = true;
      this.$emit('close')
    },

    onAmountInput(e) {
      let val = e.target.value;

      // Allow only digits and a single dot
      val = val.replace(/[^0-9.]/g, '');

      // Prevent multiple dots
      const parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      // Max 2 decimal places
      if (parts[1] !== undefined && parts[1].length > 2) {
        val = parts[0] + '.' + parts[1].slice(0, 2);
      }

      this.editableAmount = val;
      this.$nextTick(() => { e.target.value = val; });
    },

    validate() {
      this.ispaymentValid = false;
      this.isAmountValid = false;

      if (this.paymentmode === '' || this.paymentmode.length <= 2) {
        this.ispaymentValid = true;
      }

      const amount = parseFloat(this.editableAmount);
      if (!this.editableAmount || isNaN(amount) || amount <= 0) {
        this.isAmountValid = true;
      }

      return !this.ispaymentValid && !this.isAmountValid;
    },

    submitBilling() {
      if (this.validate()) {
        const self = this;
        if (self.BillingData) {
          self.disablesave = true;
          self.showspinner = true;
          debugger
          // Update all amount-related fields with the user-entered value
          const enteredAmount = parseFloat(self.editableAmount).toFixed(2);
          const payload = JSON.parse(JSON.stringify(self.BillingData));
          payload.service_cost = enteredAmount;
          payload.net_amount = enteredAmount;
          payload.gross_amount = enteredAmount;
          payload.amount_after_discount = enteredAmount;
          payload.payment_amount = enteredAmount;
          payload.payment_mode = self.paymentmode;
          payload.quantity = "1";
          payload.discount_percent = "";
          payload.discount_amount = "";
          payload.tax_percent = "";
          payload.tax_amount = "";

          InvoiceReceiptApi.quickcollectionbystaff(payload)
            .then((invoice) => {
              self.showspinner = false;
              self.disablesave = true;
              self.disableinvoicereceipt = false;
              self.$emit('save', self.appointmentdetails);
            })
            .catch(function (error) {
              self.showspinner = false;
              return error;
            });
        }
      }
    },
  },
  watch: {
    showmodal(val) {
      if (val) {
        document.body.classList.add('modal-open')
      } else {
        document.body.classList.remove('modal-open')
      }
    },
    BillingData: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.editableAmount = parseFloat(newVal.net_amount || 0);
      }
    }
  }
}
</script>